export const CANCEL_EXPORT_REQUEST = 'CANCEL_EXPORT_REQUEST';
export const CANCEL_EXPORT_SUCCESS = 'CANCEL_EXPORT_SUCCESS';
export const CANCEL_EXPORT_FAILED = 'CANCEL_EXPORT_FAILED';
export const CANCEL_SET_EXPORT_FILE_ID = 'CANCEL_SET_EXPORT_FILE_ID';
export const CANCEL_CLEAR_EXPORT_FILE_ID = 'CANCEL_CLEAR_EXPORT_FILE_ID';
export const MODAL_EXPORT_CSV_CLOSE = 'MODAL_EXPORT_CSV_CLOSE';
export const MODAL_EXPORT_CSV_OPEN = 'MODAL_EXPORT_CSV_OPEN';
